import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';

export const PrivacyPolicy = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} size="lg" centered scrollable>
    <Modal.Header closeButton className="border-0">
      <Modal.Title className="fw-bold">Privacy Policy</Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-4">
      <h5 className="fw-bold mb-3 text-primary">1. Information Collection</h5>
      <p className="text-muted">We collect information that you provide directly to us through our "Get a Free Quote" form, including your name, email address, phone number, and project details. This information is used solely to provide you with an accurate estimate and to communicate regarding our services.</p>
      
      <h5 className="fw-bold mb-3 text-primary">2. Use of Information</h5>
      <p className="text-muted">The information we collect is used to:</p>
      <ul className="text-muted mb-4">
        <li>Provide, maintain, and improve our services.</li>
        <li>Send you technical notices, updates, and support messages.</li>
        <li>Respond to your comments, questions, and requests.</li>
      </ul>

      <h5 className="fw-bold mb-3 text-primary">3. Data Security</h5>
      <p className="text-muted">We take reasonable measures to protect your personal information from loss, theft, misuse, and unauthorized access. We do not sell or share your personal data with third parties for marketing purposes.</p>

      <h5 className="fw-bold mb-3 text-primary">4. Contact Us</h5>
      <p className="text-muted">If you have any questions about this Privacy Policy, please contact us at apexenterprises1966@gmail.com.</p>
    </Modal.Body>
    <Modal.Footer className="border-0">
      <Button variant="secondary" onClick={onHide}>Close</Button>
    </Modal.Footer>
  </Modal>
);

export const TermsOfService = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} size="lg" centered scrollable>
    <Modal.Header closeButton className="border-0">
      <Modal.Title className="fw-bold">Terms of Service</Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-4">
      <h5 className="fw-bold mb-3 text-primary">1. Service Estimates</h5>
      <p className="text-muted">All quotes provided through the website are preliminary estimates based on the information provided. A final binding quote will only be issued after a physical inspection of the property by our technical team.</p>
      
      <h5 className="fw-bold mb-3 text-primary">2. Warranty Terms</h5>
      <p className="text-muted">Our 10-year warranty applies to specific premium waterproofing systems and is subject to the terms and conditions outlined in the final service agreement. Normal wear and tear or structural shifts beyond our control are excluded.</p>

      <h5 className="fw-bold mb-3 text-primary">3. Project Timelines</h5>
      <p className="text-muted">While we strive to adhere to projected timelines, external factors such as weather conditions (especially for exterior painting and waterproofing) may cause adjustments. We will communicate any changes promptly.</p>

      <h5 className="fw-bold mb-3 text-primary">4. Payments</h5>
      <p className="text-muted">Payment terms are as specified in the individual service contract. Usually, a commencement deposit is required followed by milestone payments.</p>
    </Modal.Body>
    <Modal.Footer className="border-0">
      <Button variant="secondary" onClick={onHide}>Close</Button>
    </Modal.Footer>
  </Modal>
);

export const Sitemap = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} size="lg" centered scrollable>
    <Modal.Header closeButton className="border-0">
      <Modal.Title className="fw-bold">Sitemap</Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-4">
      <Row>
        <Col md={6}>
          <h5 className="fw-bold mb-3 text-primary">Main Sections</h5>
          <ul className="list-unstyled text-muted mb-4">
            <li className="mb-2">🏠 Home</li>
            <li className="mb-2">🛠️ Services
              <ul className="ms-3 list-unstyled">
                <li>- Advanced Waterproofing</li>
                <li>- Premium Painting</li>
              </ul>
            </li>
            <li className="mb-2">🖼️ Our Work Gallery</li>
            <li className="mb-2">🏢 About Apex</li>
            <li className="mb-2">📞 Contact Us</li>
            <li className="mb-2">📝 Get a Quote</li>
          </ul>
        </Col>
        <Col md={6}>
          <h5 className="fw-bold mb-3 text-primary">Legal & Support</h5>
          <ul className="list-unstyled text-muted">
            <li className="mb-2">📜 Privacy Policy</li>
            <li className="mb-2">📑 Terms of Service</li>
            <li className="mb-2">💬 Testimonials</li>
            <li className="mb-2">❓ FAQ</li>
            <li className="mb-2">🟢 WhatsApp Support</li>
          </ul>
        </Col>
      </Row>
    </Modal.Body>
    <Modal.Footer className="border-0">
      <Button variant="secondary" onClick={onHide}>Close</Button>
    </Modal.Footer>
  </Modal>
);